import { DonutChartData } from 'components/Charts/DonutChart';
import { useRef, useState } from 'react';
import { useScrollArrows } from './useScrollArrows';

export const useChart = (data: DonutChartData[]) => {
  const dataSet = data.filter((type) => type.y > 0); // separate labels from data to not show 0 data
  const [hoveredDatum, setHoveredDatum] = useState<
    DonutChartData | undefined
  >();

  const legendItemRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const {
    containerRef: legendContainerRef,
    isScrollable,
    scrollDirection,
    handleArrowClick,
  } = useScrollArrows();

  const scrollToLegendItem = (label: string | undefined) => {
    if (label && legendItemRefs.current[label]) {
      legendItemRefs.current[label]?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  };

  return {
    scrollToLegendItem,
    handleArrowClick,
    isScrollable,
    hoveredDatum,
    setHoveredDatum,
    dataSet,
    legendItemRefs,
    legendContainerRef,
    scrollDirection,
  };
};
